export class FormControl {
    controlName: string;
    value: any;

    constructor(controlName: string, value: any) {
        this.controlName = controlName;
        this.value = value;
    }
}
